import { escalation } from "../api/escalation-api";
import { appState, dispatch } from "../redux/redux-config";

const escalationActions = {
  loadLevels: async function (messageTypes) {
    const state = appState();
    const token = state.user.token;
    try {
      const response = await escalation.getLevels(token, messageTypes);
      if (response && response.success) {
        const list = (response.list || response.levels || []).map((l) => ({
          value: l.id || l.value,
          label: l.name || l.label,
          priority: l.priority || l.order || 0,
        }));
        dispatch("ESCALATION_LEVELS_LOADED", { levels: list });
        return list;
      }
    } catch (err) {
      // swallow for now; could dispatch error state
      console.error("Failed to load escalation levels", err);
    }
    return [];
  },
  setSelection: function (mode, level) {
    dispatch("ESCALATION_SELECTION_CHANGED", { mode, level });
  },
};
export default escalationActions;

export function escalationReducer(state, action) {
  if (state === undefined) return initialState;
  switch (action.type) {
    case "ESCALATION_LEVELS_LOADED":
      return { ...state, levels: action.payload.levels };
    case "ESCALATION_SELECTION_CHANGED":
      return { ...state, mode: action.payload.mode, selectedLevel: action.payload.level };
    case "LOGOUT":
      return initialState;
    default:
      return state;
  }
}

const initialState = {
  levels: [],
  mode: "specify",
  selectedLevel: "",
};
